// extracted by mini-css-extract-plugin
export default {"roleSelection":"update_roleSelection__qtTou"};